const postalCodes = {
    "Ariana": "2080",
    "Ettadhamen": "2041",
    "Raoued": "2083",
    "Sidi Thabet": "2020",
    "La Soukra": "2036",
    "Mnihla": "2094",
    
    "Tunis": "1000",
    "Le Bardo": "2000",
    "La Marsa": "2070",
    "Le Kram": "2089",
    "Carthage": "2016",
    "El Menzah": "2091",
    "Sidi Hassine": "2061",
  
    "Ben Arous": "2013",
    "Ezzahra": "2034",
    "Hammam Lif": "2050",
    "Radès": "2040",
    "Mornag": "2090",
    "Mohamedia": "1133",
    "Fouchana": "2082",
  
    "Nabeul": "8000",
    "Hammamet": "8050",
    "Korba": "8070",
    "Kelibia": "8090",
    "Soliman": "8020",
    "Menzel Temime": "8080",
    "Takelsa": "8044",
  
    "Bizerte": "7000",
    "Menzel Bourguiba": "7050",
    "Ras Jebel": "7070",
    "Mateur": "7030",
    "Tinja": "7040",
  
    "Beja": "9000",
    "Testour": "9010",
    "Medjez el Bab": "9070",
    "Teboursouk": "9030",
  
    "Jendouba": "8100",
    "Ain Draham": "8130",
    "Ghardimaou": "8110",
    "Bou Salem": "8170",
  
    "Kef": "7100",
    "Dahmani": "7110",
    "Sakiet Sidi Youssef": "7130",
    "Tajerouine": "7150",
  
    "Siliana": "6100",
    "Makthar": "6110",
    "Bou Arada": "6150",
    "Kesra": "6120",
  
    "Kairouan": "3100",
    "Oueslatia": "3120",
    "Sbikha": "3110",
    "Haffouz": "3160",
  
    "Sousse": "4000",
    "Msaken": "4070",
    "Hammam Sousse": "4011",
    "Akouda": "4022",
    "Kalâa Kebira": "4060",
    "Kalâa Seghira": "4021",
  
    "Monastir": "5000",
    "Sahline": "5012",
    "Jemmal": "5020",
    "Ksibet el Mediouni": "5040",
    "Bekalta": "5060",
  
    "Mahdia": "5100",
    "Chebba": "5170",
    "Ksour Essef": "5180",
    "El Jem": "5160",
  
    "Sfax": "3000",
    "Sakiet Eddaier": "3021",
    "Sakiet Ezzit": "3021",
    "Thyna": "3032",
    "Agareb": "3070",
    "Mahres": "3040",
    "Kerkennah": "3078",
  
    "Gabes": "6000",
    "Mareth": "6050",
    "Matmata": "6040",
    "Ghannouch": "6011",
    "El Hamma": "6020",
  
    "Medenine": "4100",
    "Ben Guerdane": "4160",
    "Zarzis": "4170",
    "Djerba": "4180",
  
    "Tataouine": "3200",
    "Bir Lahmar": "3250",
    "Ghomrassen": "3220",
  
    "Gafsa": "2100",
    "Métlaoui": "2130",
    "Redeyef": "2110",
    "Mdhilla": "2140",
  
    "Tozeur": "2200",
    "Nefta": "2240",
    "Degache": "2220",
  
    "Kebili": "4200",
    "Douz": "4260",
    "Souk Lahad": "4210"
  };
  
  export default postalCodes;
  